import { Product } from '../model/product';

export const PRODUCTS: Product[] = [
  {
    id: 1,
    inventories: [],
    title: 'Organic Apples',
    description: 'Fresh and organic apples from local farms',
    sku_plu: '1001',
    unit: 'kg',
    stock: 50,
    cost: 2.5,
    price: 100,
    category: 1,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 2,
    inventories: [],
    title: 'Premium Tomatoes',
    description: 'Ripe and juicy tomatoes, perfect for salads',
    sku_plu: '1002',
    unit: 'kg',
    stock: 30,
    cost: 1.75,
    price: 300,
    category: 2,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 3,
    inventories: [],
    title: 'Organic Milk',
    description: 'Fresh organic milk from grass-fed cows',
    sku_plu: '1003',
    unit: 'liters',
    stock: 20,
    cost: 1.99,
    price: 500,
    category: 3,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 4,
    inventories: [],
    title: 'Grass-fed Beef',
    description: 'High-quality grass-fed beef, tender and delicious',
    sku_plu: '1004',
    unit: 'kg',
    stock: 15,
    cost: 8.5,
    price: 1000,
    category: 4,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 5,
    inventories: [],
    title: 'Whole Wheat Bread',
    description: 'Freshly baked whole wheat bread, rich in fiber',
    sku_plu: '1005',
    unit: 'loaf',
    stock: 40,
    cost: 1.25,
    price: 150,
    category: 5,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 6,
    inventories: [],
    title: 'Organic Green Beans',
    description: 'Crisp and fresh organic green beans',
    sku_plu: '1006',
    unit: 'kg',
    stock: 25,
    cost: 3.0,
    price: 200,
    category: 1,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 7,
    inventories: [],
    title: 'Canned Chickpeas',
    description: 'Premium quality canned chickpeas',
    sku_plu: '1007',
    unit: 'can',
    stock: 60,
    cost: 0.75,
    price: 250,
    category: 2,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 8,
    inventories: [],
    title: 'Mixed Nuts',
    description: 'Healthy and delicious mixed nuts',
    sku_plu: '1008',
    unit: 'kg',
    stock: 35,
    cost: 7.0,
    price: 350,
    category: 3,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 9,
    inventories: [],
    title: 'Orange Juice',
    description: 'Freshly squeezed orange juice, no added sugar',
    sku_plu: '1009',
    unit: 'liters',
    stock: 50,
    cost: 2.25,
    price: 400,
    category: 4,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
  {
    id: 10,
    inventories: [],
    title: 'Ground Cinnamon',
    description: 'Premium ground cinnamon for baking and cooking',
    sku_plu: '1010',
    unit: 'g',
    stock: 70,
    cost: 1.0,
    price: 450,
    category: 5,
    status: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    totalRecord: 0,
    categoryCount: 0,
    imageCount: 0,
    descriptionCount: 0,
  },
].map((p) => Product.fromJSON(p));
